import { render, staticRenderFns } from "./ClienteForm.vue?vue&type=template&id=7354a943&scoped=true"
import script from "./ClienteForm.vue?vue&type=script&lang=ts"
export * from "./ClienteForm.vue?vue&type=script&lang=ts"
import style0 from "./ClienteForm.vue?vue&type=style&index=0&id=7354a943&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7354a943",
  null
  
)

export default component.exports